export const NAME = 'connectedSnackbar' +
    '';